import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CookieConsentProvider } from "./hooks/useCookieConsent";
import CookieBanner from "./components/CookieBanner";
import CookiePreferencesModal from "./components/CookiePreferencesModal";

function App() {
  return (
    <CookieConsentProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
          <CookieBanner />
          <CookiePreferencesModal />
        </BrowserRouter>
      </I18nextProvider>
    </CookieConsentProvider>
  );
}

export default App;